import React from "react";
import { FormInstance } from "antd";
import type { Rule } from "antd/es/form";
import { GET_ORGANIZERS_CURSOR } from "graphql/query/organizer-gql";
import { FormElements } from "components/layout";
import { TFlooringVariation } from "../../helpers/flooring-variation-types-helper";

interface IFlooringVariationOrganizerSelectProps
{
  form: FormInstance;
  variation?: TFlooringVariation;
  location?: boolean;
  skipQuery?: boolean;
  rules?: Rule[];
}

const FlooringVariationOrganizerSelect: React.FC<IFlooringVariationOrganizerSelectProps> = ({
  form,
  variation,
  location = true,
  skipQuery = true,
  rules = [],
}) => (
  <FormElements.RadioSelect
    form={form}
    query={GET_ORGANIZERS_CURSOR}
    model="organizersCursor"
    name="organizer_id"
    label="FORMS.Input_Label_Organizer"
    modalTitle="FORMS.Title_AddOrganizer"
    location={location}
    skipQuery={skipQuery}
    initialValue={
      variation?.relOrganizer?.id
        ? [
          {
            value: variation.relOrganizer.id,
            label: variation.relOrganizer.title,
          },
        ]
        : undefined
    }
    rules={rules}
  />
);

export default FlooringVariationOrganizerSelect;
